export default (url, append) => {
  const [path, query] = url.split("?");
  return `${path}/${append}${query ? `?${query}` : ""}`;
};
